import { StyleSheet, Text, View } from "react-native";
import React from "react";

import DashedLine from "react-native-dashed-line";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../components/CustomComponent";
import { Colors } from "../../../../globalStyles/ColorConfig";
import dimensions from "../../../../globalStyles/dimensions";
import ExperienceIcons from "../../../../assets/Icons/ExperienceIcons";
import BookingsIcons from "../../../../assets/Icons/BookingsIcons";

type PriceCardProps = {
  price?: any;
};

const PriceDetails: React.FC<PriceCardProps> = ({ price }) => {

  return (
    <View>
      <View>
        <Text
          style={[
            GlobalStyles.title1,
            {
              fontSize: 26,
            },
          ]}
        >
          Price details
        </Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View style={[styles.card, styles.shadowProp]}>
          <View style={styles.experience}>
            <Text style={[GlobalStyles.bodyText, { lineHeight: 35 }]}>
              Experience
            </Text>
            <Text style={[GlobalStyles.bodyText, { lineHeight: 35 }]}>
              ${price}
            </Text>
          </View>

          <View style={{ width: "94%", alignSelf: "center", opacity: 0.3 }}>
            <DashedLine dashThickness={1.2} dashGap={4} />
          </View>

          <View style={styles.total}>
            <Text style={[GlobalStyles.bodyTextBold, { lineHeight: 35 }]}>
              Total
            </Text>
            <Text style={[GlobalStyles.bodyTextBold, { lineHeight: 35 }]}>
              ${price}
            </Text>
          </View>
          <CustomComponent.SolidDivider
            style={{
              width: "94%",
              height: 0.6,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.3,
              marginVertical: dimensions.marginVertical * 1.2,
            }}
          />
          <View style={styles.download}>
            <Text style={{ marginTop: -5 }}>
              <BookingsIcons.DownloadIcons />
            </Text>
            <Text>
              <BookingsIcons.DownloadInvoiceTextIcons />
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default PriceDetails;

const styles = StyleSheet.create({
  // pricedetails:{
  //     [GlobalStyles.heading2, ]
  // },
  card: {
    backgroundColor: "white",
    borderRadius: 6,
    height: 150,
    width: "96%",
    padding: 15,
  },
  shadowProp: {
    shadowColor: Colors.black50,
    elevation: 4,
  },
  experience: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 10,
  },
  taxes: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 10,
  },
  total: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 10,
  },
  download: {
    // display:'flex',
    flexDirection: "row",
    // borderWidth:1,
    alignSelf: "center",
    padding: 5,
    marginTop: 5,
  },
});
